(() => {
	const questionConfig = [
		{
			id: "goal",
			stepLabel: "Tavoite",
			question: "Mikä on tavoitteesi?",
			options: [
				{ value: "muscle_gain", label: "Lihaskasvu", icon: "arm" },
				{ value: "fat_loss", label: "Rasvanpoltto", icon: "fire" },
				{ value: "toning", label: "Kiinteytyminen", icon: "shines" },
			],
		},
		{
			id: "level",
			stepLabel: "Taso",
			question: "Mikä kuvaa parhaiten tasoasi?",
			options: [
				{ value: "beginner", label: "Aloittelija", icon: "stars-1" },
				{ value: "intermediate", label: "Keskitaso", icon: "stars-2" },
				{ value: "advanced", label: "Edistynyt", icon: "stars-3" },
			],
		},
		{
			id: "gender",
			stepLabel: "Sukupuoli",
			question: "Kumpi kuvaa sinua paremmin?",
			options: [
				{ value: "male", label: "Mies", icon: "man" },
				{ value: "female", label: "Nainen", icon: "woman" },
			],
		},
		{
			id: "weekly_training",
			stepLabel: "Treenit",
			question: "Montako treeniä viikossa pystyt tekemään?",
			options: [
				{ value: "one_two", label: "1-2", icon: "barbell" },
				{ value: "three_four", label: "3-4", icon: "barbell" },
				{ value: "four_five", label: "4-5", icon: "barbell" },
			],
		},
		{
			id: "focus",
			stepLabel: "Painotus",
			question: "Haluatko painottaa kehitystä erityisesti johonkin?",
			options: [
				{ value: "whole_body", label: "Koko keho", icon: "whole-body" },
				{ value: "lower_body", label: "Alakroppa", icon: "lower-body" },
				{ value: "upper_body", label: "Yläkroppa", icon: "upper-body" },
			],
		},
		{
			id: "special_considerations",
			stepLabel: "Huomioitavaa",
			question: "Onko sinulla jotain näistä, jotka pitäisi huomioida?",
			options: [
				{ value: "diet", label: "Erikoisruokavalio", icon: "healthy-food" },
				{ value: "allergies", label: "Allergioita", icon: "dust" },
				{ value: "injuries", label: "Isoja vammoja", icon: "red-cross" },
				{ value: "none", label: "Ei mitään näistä", icon: "check-image" },
			],
		},
	];

	const QUESTION_CONFIG = questionConfig;
	const RESULT_STEP_LABEL = "Tulos";
	const SPECIAL_CONSIDERATION_VALUES = ["diet", "allergies", "injuries"];
	const DEFAULT_AYRTON_IMAGE = "https://cdn.shopify.com/s/files/1/1029/3110/4092/files/Henkilokuva_Ayrton_1b35a574-1ae8-41bf-b520-a9f33aaef24b.jpg?v=1780949423";
	const COACHING_URL = "https://ayrtonkalek.fi/pages/henkilokohtainen-valmennus";
	const PROGRAM_CATALOG = {
		starter_gains: {
			key: "starter_gains",
			title: "Starter Gains",
			url: "https://ayrtonkalek.fi/products/starter-gains-aloittelijan-treeniohjelma",
			kind: "program",
		},
		diet_4_meals: {
			key: "diet_4_meals",
			title: "Rasvanpoltto 4 ateriaa ravinto-ohjelma",
			url: "https://ayrtonkalek.fi/products/diet-4-ateriaa-ravinto-ohjelma",
			kind: "program",
		},
		gains_4_meals: {
			key: "gains_4_meals",
			title: "Lihaskasvu 4 ateriaa ravinto-ohjelma",
			url: "https://ayrtonkalek.fi/products/gains-4-ateriaa-ravinto-ohjelma",
			kind: "program",
		},
		express_gains: {
			key: "express_gains",
			title: "Express Gains",
			url: "https://ayrtonkalek.fi/products/express-gains-treeniohjelma",
			kind: "program",
		},
		mega_gains_2_2: {
			key: "mega_gains_2_2",
			title: "Upper/Lower Gains 2+2 -jakoinen bodaustreeniohjelma",
			url: "https://ayrtonkalek.fi/products/upper-lower-gains-2-2-jakoinen-bodaustreeniohjelma",
			kind: "program",
		},
		mega_gains_3_2: {
			key: "mega_gains_3_2",
			title: "Mega Gains 3+2",
			url: "https://ayrtonkalek.fi/products/mega-gains-3-2-jako-treeniohjelma",
			kind: "program",
		},
		wellness_gains: {
			key: "wellness_gains",
			title: "Wellness Gains",
			url: "https://ayrtonkalek.fi/products/wellness-gains-treeniohjelma",
			kind: "program",
		},
		big_wheels: {
			key: "big_wheels",
			title: "Big Wheels",
			url: "https://ayrtonkalek.fi/products/big-wheels-treeniohjelma",
			kind: "program",
		},
		coaching: {
			key: "coaching",
			title: "Henkilökohtainen valmennus",
			url: COACHING_URL,
			image: DEFAULT_AYRTON_IMAGE,
			imageAlt: "Ayrton Kalek",
			kind: "coaching",
		},
	};
	const HEALTH_NOTICE_TEXT_BY_VALUE = {
		diet: "Jos sinulla on erikoisruokavalio ja koet, että se tuo lisähaastetta treenaamiseen, palautumiseen tai tavoitteelliseen syömiseen, henkilökohtainen valmennus voi olla todella hyvä vaihtoehto. Silloin kokonaisuus voidaan rakentaa juuri sinun arkeesi sopivaksi.",
		allergies: "Jos sinulla on allergioita ja koet, että ne vaikeuttavat syömistä, palautumista tai tavoitteellista etenemistä, henkilökohtainen valmennus voi olla järkevä vaihtoehto. Näin kokonaisuus voidaan suunnitella niin, että se toimii käytännössä juuri sinun tilanteessasi.",
		injuries: "Jos sinulla on isompia vammoja ja koet, että ne haittaavat treenaamista tai liikkeiden tekemistä, henkilökohtainen valmennus voi olla erittäin hyödyllinen ratkaisu. Näin treeni voidaan rakentaa turvallisesti ja tavoitteellisesti juuri sinun tilanteesi huomioiden.",
	};
	const BEGINNER_COACHING_TEXT = "Aloittelijana henkilökohtainen valmennus voi tehdä startista helpomman, koska tekniikka, treenirytmi ja koko tekemisen rakenne saadaan kuntoon heti alusta asti.";
	const LOW_VOLUME_COACHING_TEXT = "Kun treenimäärä on 1-2 kertaa viikossa, henkilökohtainen valmennus auttaa käyttämään rajalliset treenit mahdollisimman tehokkaasti. Pienikin määrä voi toimia hyvin, kun kokonaisuus suunnitellaan oikein.";

	function imageIcon(src) {
		return `<img class="ayrton-recommender__icon-image" src="${src}" alt="" loading="lazy" aria-hidden="true">`;
	}

	function starIcon(filled) {
		const fill = filled ? "#E4C085" : "none";
		return `<svg class="ayrton-recommender__star" aria-hidden="true" viewBox="0 0 24 24" fill="${fill}"><path d="m12 2.8 2.8 5.7 6.3.9-4.6 4.5 1.1 6.3-5.6-3-5.6 3 1.1-6.3-4.6-4.5 6.3-.9L12 2.8Z" stroke="#E4C085" stroke-width="1.8" stroke-linejoin="round"/></svg>`;
	}

	function starsIcon(filledCount) {
		return `<span class="ayrton-recommender__stars" aria-hidden="true">${[1, 2, 3]
			.map((index) => starIcon(index <= filledCount))
			.join("")}</span>`;
	}

	const ICONS = {
		arm: imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/arm.png?v=1781713744"),
		fire: imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/fire_1.png?v=1781713745"),
		shines: imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/shines_1.png?v=1781713744"),
		"stars-1": starsIcon(1),
		"stars-2": starsIcon(2),
		"stars-3": starsIcon(3),
		barbell: imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/barbell.png?v=1781714988"),
		man: imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/man.png?v=1781713743"),
		woman: imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/female-and-male-shapes-silhouettes.png?v=1781713744"),
		"whole-body": imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/man_3.png?v=1781713744"),
		"lower-body": imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/men-legs.png?v=1781713744"),
		"upper-body": imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/body.png?v=1781713744"),
		"healthy-food": imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/healthy-food.png?v=1781713744"),
		dust: imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/dust.png?v=1781713744"),
		"red-cross": imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/red-cross.png?v=1781713744"),
		"check-image": imageIcon("https://cdn.shopify.com/s/files/1/1029/3110/4092/files/check_5.png?v=1781713744"),
		check: '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="m5 13 4 4L19 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
	};

	function escapeHTML(value) {
		const node = document.createElement("div");
		node.textContent = value == null ? "" : String(value);
		return node.innerHTML;
	}

	function escapeAttribute(value) {
		return escapeHTML(value).replace(/"/g, "&quot;");
	}

	function safeHref(value) {
		const href = value == null ? "" : String(value).trim();
		return /^javascript:/i.test(href) ? "" : href;
	}

	function getOptionLabel(questionId, value) {
		const question = QUESTION_CONFIG.find((item) => item.id === questionId);
		const option = question?.options.find((item) => item.value === value);
		return option?.label || "";
	}

	function getProgram(programKey, programData = {}) {
		const baseProgram = PROGRAM_CATALOG[programKey] || PROGRAM_CATALOG.express_gains;
		const media = programData?.[programKey] || {};

		return {
			...baseProgram,
			image: media.image || baseProgram.image || "",
			imageAlt: media.imageAlt || baseProgram.imageAlt || baseProgram.title,
		};
	}

	function getCommentTitle(value) {
		return value && value !== "Päävalmentajan huomio" ? value : "Ayrtonin kommentti";
	}

	function createDecision(primaryProgramKey, secondaryProgramKey, rule, coachingCommentType = null, tertiaryProgramKey = null) {
		const recommendations = [
			{ rank: "primary", programKey: primaryProgramKey },
			{ rank: "secondary", programKey: secondaryProgramKey },
		];

		if (tertiaryProgramKey) {
			recommendations.push({ rank: "tertiary", programKey: tertiaryProgramKey });
		}

		return {
			rule,
			coachingCommentType,
			recommendations,
		};
	}

	function decisionResolver(answers) {
		if (answers.level === "beginner") {
			const nutritionProgramKey = answers.goal === "muscle_gain" ? "gains_4_meals" : "diet_4_meals";
			return createDecision("starter_gains", nutritionProgramKey, `level_beginner_${answers.goal}`, "beginner", "coaching");
		}

		if (answers.weekly_training === "one_two") {
			return createDecision("coaching", "starter_gains", "low_training_volume", "low_volume");
		}

		if (answers.weekly_training === "three_four") {
			if (answers.focus === "lower_body" && answers.gender === "female") {
				return createDecision("wellness_gains", "mega_gains_2_2", "three_four_lower_body_female");
			}

			if (answers.focus === "lower_body" && answers.gender === "male") {
				return createDecision("mega_gains_2_2", "express_gains", "three_four_lower_body_male");
			}

			if (answers.focus === "upper_body") {
				return createDecision("mega_gains_2_2", "express_gains", "three_four_upper_body");
			}

			return createDecision("mega_gains_2_2", "express_gains", "three_four_whole_body");
		}

		if (answers.weekly_training === "four_five") {
			if (answers.focus === "lower_body" && answers.gender === "female") {
				return createDecision("wellness_gains", "mega_gains_3_2", "four_five_lower_body_female");
			}

			if (answers.focus === "lower_body" && answers.gender === "male") {
				return createDecision("big_wheels", "mega_gains_3_2", "four_five_lower_body_male");
			}

			if (answers.focus === "upper_body") {
				return createDecision("mega_gains_3_2", "big_wheels", "four_five_upper_body");
			}

			return createDecision("mega_gains_3_2", "express_gains", "four_five_whole_body");
		}

		return createDecision("express_gains", "starter_gains", "fallback");
	}

	function getCoachingComment(settings, coachingCommentType) {
		if (coachingCommentType === "beginner") {
			return {
				title: getCommentTitle(settings.beginnerCoachingCommentTitle),
				text: settings.beginnerCoachingCommentText || BEGINNER_COACHING_TEXT,
				ctaLabel: settings.beginnerCoachingCtaLabel || "Lue Valmennuksesta",
				ctaUrl: settings.beginnerCoachingCtaUrl || COACHING_URL,
			};
		}

		if (coachingCommentType === "low_volume") {
			return {
				title: getCommentTitle(settings.lowVolumeCoachingCommentTitle),
				text: settings.lowVolumeCoachingCommentText || LOW_VOLUME_COACHING_TEXT,
				ctaLabel: settings.lowVolumeCoachingCtaLabel || "Lue Valmennuksesta",
				ctaUrl: settings.lowVolumeCoachingCtaUrl || COACHING_URL,
			};
		}

		return {
			title: getCommentTitle(),
			text: "Henkilökohtaisessa valmennuksessa kokonaisuus rakennetaan suoraan sinun tavoitteidesi, arjen ja lähtötason ympärille.",
			ctaLabel: "Lue Valmennuksesta",
			ctaUrl: COACHING_URL,
		};
	}

	function buildProgramReason(answers, rank) {
		const goalCopy = {
			muscle_gain: {
				reason: "Tavoitteesi painottuu lihasmassan kehittämiseen, joten suositus ohjaa sinut nousujohteiseen ja selkeästi rytmitettyyn tekemiseen.",
			},
			fat_loss: {
				reason: "Tavoitteesi painottuu rasvanpolttoon, joten suositus tukee säännöllistä harjoittelua ja kokonaisuuden hallintaa.",
			},
			toning: {
				reason: "Tavoitteesi painottuu kiinteytymiseen, joten suositus sopii treeniin, jossa haetaan ryhtiä, tuntumaa ja jatkuvuutta.",
			},
		};

		const levelCopy = {
			beginner: "Aloittelijana hyödyt erityisesti selkeästä rakenteesta ja sopivasta etenemistahdista.",
			intermediate: "Keskitasolla hyvä ohjelma auttaa pitämään kehityksen suunnassa ja treeniviikot hallittuina.",
			advanced: "Edistyneellä tasolla korostuvat ohjelman rytmitys, kuormituksen hallinta ja laadukas toisto.",
		};

		const trainingCopy = {
			one_two: "Valitsemasi 1-2 treeniä viikossa tekee suunnitelman realistisuudesta erityisen tärkeää.",
			three_four: "Valitsemasi 3-4 treeniä viikossa antaa hyvän pohjan tasaiselle kehitykselle.",
			four_five: "Valitsemasi 4-5 treeniä viikossa mahdollistaa monipuolisen ja nousujohteisen kokonaisuuden.",
		};

		const focusCopy = {
			whole_body: "Painotus on koko kehossa, joten kokonaisuuden tasapaino on hyvä pitää mukana alusta asti.",
			lower_body: "Alakroppapainotus voidaan huomioida harjoittelun valinnoissa ilman, että kokonaisuus kärsii.",
			upper_body: "Yläkroppapainotus voidaan rakentaa mukaan niin, että muu harjoittelu tukee sitä.",
		};

		const prefix = rank === "secondary"
			? "Tämä on toinen vahva vaihtoehto, jos haluat verrata eri ohjelmapolkua samaan tavoitteeseen."
			: "";
		const goal = goalCopy[answers.goal] || goalCopy.toning;

		return [prefix, goal.reason, levelCopy[answers.level], trainingCopy[answers.weekly_training], focusCopy[answers.focus]]
			.filter(Boolean)
			.join(" ");
	}

	function buildNutritionReason(answers, programKey) {
		if (programKey === "gains_4_meals") {
			return "Lihaskasvutavoitteessa riittävä ja säännöllinen syöminen tukee harjoittelusta palautumista ja kehitystä. GAINS 4 ateriaa -ravinto-ohjelma antaa aloittelijalle helposti seurattavan neljän aterian päivärytmin Starter Gains -ohjelman rinnalle.";
		}

		if (answers.goal === "fat_loss") {
			return "Rasvanpolttotavoitteessa ravinnon selkeä rakenne tukee treeniohjelman noudattamista. DIET 4 ateriaa -ravinto-ohjelma antaa aloittelijalle helposti seurattavan neljän aterian päivärytmin Starter Gains -ohjelman rinnalle.";
		}

		return "Kiinteytymistavoitteessa säännöllinen syöminen tukee harjoittelua ja kokonaisuuden hallintaa. DIET 4 ateriaa -ravinto-ohjelma antaa aloittelijalle helposti seurattavan neljän aterian päivärytmin Starter Gains -ohjelman rinnalle.";
	}

	function personalizationResolver(answers, decision, settings, programData = {}) {
		const primaryCtaLabel = settings.primaryCtaLabelDefault || "Katso ohjelma";
		const secondaryCtaLabel = settings.secondaryCtaLabelDefault || "Katso toinen vaihtoehto";

		return decision.recommendations.map((recommendation) => {
			const product = getProgram(recommendation.programKey, programData);
			const isPrimary = recommendation.rank === "primary";
			const isCoaching = product.kind === "coaching";
			const isNutritionProgram = ["diet_4_meals", "gains_4_meals"].includes(recommendation.programKey);
			const badge = isCoaching
				? "Valmennussuositus"
				: isPrimary
					? "Ensisijainen ohjelmasuositus"
					: "Toissijainen ohjelmasuositus";

			if (isCoaching) {
				const coachingComment = getCoachingComment(settings, decision.coachingCommentType);
				return {
					...recommendation,
					product,
					badge,
					reason: "Henkilökohtainen valmennus on tässä valinnassa vahva vaihtoehto, koska kokonaisuus voidaan rakentaa suoraan sinun tilanteeseesi.",
					ctaLabel: coachingComment.ctaLabel,
					ctaUrl: coachingComment.ctaUrl,
					noteTitle: coachingComment.title,
					noteText: coachingComment.text,
				};
			}

			return {
				...recommendation,
				product,
				badge,
				reason: isNutritionProgram
					? buildNutritionReason(answers, recommendation.programKey)
					: buildProgramReason(answers, recommendation.rank),
				ctaLabel: isPrimary ? primaryCtaLabel : secondaryCtaLabel,
				ctaUrl: product.url,
			};
		});
	}

	function healthNoticeResolver(answers, settings) {
		if (!SPECIAL_CONSIDERATION_VALUES.includes(answers.special_considerations)) return null;

		return {
			title: getCommentTitle(settings.healthCommentTitle),
			text: HEALTH_NOTICE_TEXT_BY_VALUE[answers.special_considerations],
			ctaLabel: settings.healthCommentCtaLabel || "Lue Valmennuksesta",
			ctaUrl: settings.healthCommentCtaUrl || COACHING_URL,
		};
	}

	function outcomeResolver(answers, config) {
		const settings = config.settings || {};
		const programData = config.programs || {};
		const decision = decisionResolver(answers);
		const healthNotice = answers.level === "beginner" ? null : healthNoticeResolver(answers, settings);
		const recommendations = personalizationResolver(answers, decision, settings, programData);

		if (healthNotice) {
			const programRecommendation = recommendations.find((recommendation) => recommendation.product?.kind === "program");

			return {
				mode: "program_recommendation_with_coach_comment",
				decisionRule: decision.rule,
				recommendations: programRecommendation
					? [
						{
							...programRecommendation,
							rank: "primary",
							badge: "Ohjelmasuositus",
							reason: buildProgramReason(answers, "primary"),
							ctaLabel: settings.primaryCtaLabelDefault || programRecommendation.ctaLabel || "Katso ohjelma",
						},
					]
					: [],
				healthNotice,
			};
		}

		return {
			mode: "program_recommendation",
			decisionRule: decision.rule,
			recommendations,
			healthNotice: null,
		};
	}

	function renderButton(label, href, style = "primary") {
		if (!label) return "";

		const buttonHref = safeHref(href);
		const labelAttribute = escapeAttribute(label);
		const hrefAttribute = buttonHref ? ` href="${escapeAttribute(buttonHref)}"` : "";
		const disabledAttributes = buttonHref ? "" : ' aria-disabled="true" tabindex="-1"';
		const wrapperClass = style === "primary" ? "button_wrapper custom-hover" : "button_wrapper";

		return `
			<div class="${wrapperClass}">
				<a${hrefAttribute}${disabledAttributes} aria-label="${labelAttribute}" data-button-text="${labelAttribute}" class="button button--${style}">
					<div class="button__content">
						<span class="button__label" data-label="${labelAttribute}">${escapeHTML(label)}</span>
					</div>
					<span class="button_circle"></span>
				</a>
			</div>
		`;
	}

	if (!customElements.get("ayrton-product-recommender")) {
		class AyrtonProductRecommender extends HTMLElement {
			connectedCallback() {
				if (this.initialized) return;

				this.initialized = true;
				this.answers = {};
				this.currentStepIndex = 0;
				this.pendingAdvance = null;
				this.config = this.readConfig();
				this.sectionId = this.config.sectionId || this.dataset.sectionId || Math.random().toString(36).slice(2);
				this.stepPills = this.querySelector("[data-step-pills]");
				this.progressFill = this.querySelector("[data-progress-fill]");
				this.progressMeter = this.querySelector("[data-progress-meter]");
				this.form = this.querySelector("[data-question-form]");
				this.questionRegion = this.querySelector("[data-question-region]");
				this.resultRegion = this.querySelector("[data-result-region]");

				this.addEventListener("change", this.handleChange.bind(this));
				this.addEventListener("click", this.handleClick.bind(this));

				this.render();
			}

			readConfig() {
				const configScript = this.querySelector("[data-ayrton-config]");
				if (!configScript) return { programs: {}, settings: {} };

				try {
					const parsed = JSON.parse(configScript.textContent);
					return {
						programs: parsed.programs || {},
						settings: parsed.settings || {},
						sectionId: parsed.sectionId,
					};
				} catch (error) {
					console.warn("Ayrton product recommender config could not be parsed.", error);
					return { programs: {}, settings: {} };
				}
			}

			handleChange(event) {
				const input = event.target.closest("[data-answer-input]");
				if (!input) return;

				const questionId = input.dataset.questionId;
				const questionIndex = QUESTION_CONFIG.findIndex((question) => question.id === questionId);
				if (questionIndex < 0) return;

				this.answers[questionId] = input.value;
				this.syncAnswerDataAttributes();
				this.render();

				this.scheduleAdvance(questionIndex);
			}

			handleClick(event) {
				const stepButton = event.target.closest("[data-step-button]");
				if (stepButton) {
					event.preventDefault();
					if (stepButton.getAttribute("aria-disabled") === "true") return;
					this.goToStep(Number(stepButton.dataset.stepIndex));
					return;
				}

				const backButton = event.target.closest("[data-back-button]");
				if (backButton) {
					event.preventDefault();
					this.goToStep(Math.max(this.currentStepIndex - 1, 0));
					return;
				}

				const restartButton = event.target.closest("[data-restart-button]");
				if (restartButton) {
					event.preventDefault();
					this.answers = {};
					this.goToStep(0);
					return;
				}

				const answerCard = event.target.closest("[data-answer-card]");
				if (answerCard) {
					const questionId = answerCard.dataset.questionId;
					const answerValue = answerCard.dataset.answerValue;
					const questionIndex = QUESTION_CONFIG.findIndex((question) => question.id === questionId);

					if (questionIndex >= 0 && this.answers[questionId] === answerValue) {
						this.scheduleAdvance(questionIndex);
					}
				}
			}

			scheduleAdvance(questionIndex) {
				window.clearTimeout(this.pendingAdvance);
				this.pendingAdvance = window.setTimeout(() => {
					const nextStepIndex = Math.min(questionIndex + 1, QUESTION_CONFIG.length);
					this.goToStep(nextStepIndex);
				}, 160);
			}

			goToStep(stepIndex) {
				window.clearTimeout(this.pendingAdvance);
				this.currentStepIndex = Math.max(0, Math.min(stepIndex, QUESTION_CONFIG.length));
				this.render();
			}

			isComplete() {
				return QUESTION_CONFIG.every((question) => Boolean(this.answers[question.id]));
			}

			firstIncompleteIndex() {
				const incompleteIndex = QUESTION_CONFIG.findIndex((question) => !this.answers[question.id]);
				return incompleteIndex === -1 ? QUESTION_CONFIG.length : incompleteIndex;
			}

			progressValue() {
				return Math.round(((this.currentStepIndex + 1) / (QUESTION_CONFIG.length + 1)) * 100);
			}

			syncAnswerDataAttributes() {
				QUESTION_CONFIG.forEach((question) => {
					const attributeName = `answer${question.id.replace(/(^|_)([a-z])/g, (_, prefix, letter) => letter.toUpperCase())}`;
					if (this.answers[question.id]) {
						this.dataset[attributeName] = this.answers[question.id];
					} else {
						delete this.dataset[attributeName];
					}
				});
				this.dataset.answersComplete = String(this.isComplete());
			}

			updateStateDataAttributes(outcome = null) {
				const progress = this.progressValue();
				this.dataset.currentStep = String(this.currentStepIndex);
				this.dataset.progress = String(progress);

				if (outcome?.mode) {
					this.dataset.resultMode = outcome.mode;
				} else {
					delete this.dataset.resultMode;
				}

				if (this.progressFill) {
					this.progressFill.style.width = `${progress}%`;
					this.progressFill.dataset.progress = String(progress);
				}

				if (this.progressMeter) {
					this.progressMeter.setAttribute("aria-valuenow", String(progress));
					this.progressMeter.dataset.progress = String(progress);
				}
			}

			render() {
				this.syncAnswerDataAttributes();

				if (this.currentStepIndex === QUESTION_CONFIG.length && !this.isComplete()) {
					this.currentStepIndex = this.firstIncompleteIndex();
				}

				const outcome = this.isComplete()
					? outcomeResolver(this.answers, this.config)
					: null;

				this.updateStateDataAttributes(outcome);
				this.renderSteps();

				if (this.currentStepIndex === QUESTION_CONFIG.length) {
					this.renderResult(outcome);
				} else {
					this.renderQuestion();
				}
			}

			renderSteps() {
				const complete = this.isComplete();
				const firstIncomplete = this.firstIncompleteIndex();
				const labels = [...QUESTION_CONFIG.map((question) => question.stepLabel), RESULT_STEP_LABEL];

				this.stepPills.innerHTML = labels
					.map((label, index) => {
						const isResult = index === QUESTION_CONFIG.length;
						const isActive = index === this.currentStepIndex;
						const question = QUESTION_CONFIG[index];
						const isAnswered = isResult ? complete : Boolean(this.answers[question.id]);
						const canNavigate = isResult ? complete : index <= firstIncomplete || isAnswered;
						const state = isActive ? "active" : isAnswered ? "complete" : "upcoming";

						return `
							<button
								type="button"
								class="ayrton-recommender__step"
								data-step-button
								data-step-index="${index}"
								data-step-state="${state}"
								aria-label="${escapeAttribute(`${index + 1}. ${label}`)}"
								${isActive ? 'aria-current="step"' : ""}
								aria-disabled="${canNavigate ? "false" : "true"}"
								${canNavigate ? "" : "disabled"}
							>
								<span class="ayrton-recommender__step-number">${index + 1}</span>
								<span class="ayrton-recommender__step-label">${escapeHTML(label)}</span>
								${isAnswered && !isActive ? '<span class="ayrton-recommender__step-check" aria-hidden="true">✓</span>' : ""}
							</button>
						`;
					})
					.join("");
			}

			renderQuestion() {
				const question = QUESTION_CONFIG[this.currentStepIndex];
				const selectedValue = this.answers[question.id];
				const optionClass = question.options.length === 2 ? " ayrton-recommender__options--2" : "";

				this.form.hidden = false;
				this.resultRegion.hidden = true;

				this.questionRegion.innerHTML = `
					<fieldset class="ayrton-recommender__question" data-step="${this.currentStepIndex + 1}" data-question-id="${escapeAttribute(question.id)}">
						<legend class="ayrton-recommender__legend">
							<span class="ayrton-recommender__question-kicker">Kysymys ${this.currentStepIndex + 1} / ${QUESTION_CONFIG.length}</span>
							<span class="ayrton-recommender__question-title h4">${escapeHTML(question.question)}</span>
						</legend>
						<div class="ayrton-recommender__options${optionClass}" data-answer-group>
							${question.options.map((option) => this.renderOption(question, option, selectedValue)).join("")}
						</div>
						<div class="ayrton-recommender__actions">
							${
								this.currentStepIndex > 0
									? '<button class="ayrton-recommender__text-button" type="button" data-back-button><span aria-hidden="true">←</span><span>Takaisin</span></button>'
									: "<span></span>"
							}
						</div>
					</fieldset>
				`;
			}

			renderOption(question, option, selectedValue) {
				const inputId = `${this.sectionId}-${question.id}-${option.value}`;
				const checked = selectedValue === option.value ? "checked" : "";
				const icon = ICONS[option.icon] || ICONS.check;
				const iconModifier = option.icon.startsWith("stars-") ? " ayrton-recommender__option-icon--stars" : "";

				return `
					<label class="ayrton-recommender__option" for="${escapeAttribute(inputId)}" data-answer-card data-question-id="${escapeAttribute(question.id)}" data-answer-value="${escapeAttribute(option.value)}">
						<input
							class="ayrton-recommender__radio"
							id="${escapeAttribute(inputId)}"
							type="radio"
							name="${escapeAttribute(`${this.sectionId}-${question.id}`)}"
							value="${escapeAttribute(option.value)}"
							data-answer-input
							data-question-id="${escapeAttribute(question.id)}"
							${checked}
							required
						>
						<span class="ayrton-recommender__option-shell">
							<span class="ayrton-recommender__option-icon${iconModifier}">${icon}</span>
							<span class="ayrton-recommender__option-label">${escapeHTML(option.label)}</span>
							<span class="ayrton-recommender__option-indicator" aria-hidden="true"></span>
						</span>
					</label>
				`;
			}

			renderResult(outcome) {
				const settings = this.config.settings || {};
				const mode = outcome?.mode || "program_recommendation";
				const resultCardCount = (outcome?.recommendations || []).length + (outcome?.healthNotice ? 1 : 0);
				const recommendationCards = (outcome?.recommendations || [])
					.map((recommendation) => {
						if (recommendation?.product?.kind === "coaching") {
							return this.renderHealthNoticeCard(
								{
									title: recommendation.noteTitle || "Ayrtonin kommentti",
									text: recommendation.noteText || recommendation.reason,
									ctaLabel: recommendation.ctaLabel || "Lue Valmennuksesta",
									ctaUrl: recommendation.ctaUrl || COACHING_URL,
								},
								settings,
								"coaching",
							);
						}

						return this.renderProgramCard(recommendation);
					})
					.join("");
				const healthNoticeCard = outcome?.healthNotice ? this.renderHealthNoticeCard(outcome.healthNotice, settings) : "";

				this.form.hidden = true;
				this.resultRegion.hidden = false;
				this.resultRegion.innerHTML = `
					<div class="ayrton-recommender__result" data-step="${QUESTION_CONFIG.length + 1}" data-result-mode="${escapeAttribute(mode)}">
						<div class="ayrton-recommender__result-grid" data-result-card-count="${resultCardCount}">
							${recommendationCards}
							${healthNoticeCard}
						</div>
						<div class="ayrton-recommender__actions">
							<button class="ayrton-recommender__text-button" type="button" data-back-button><span aria-hidden="true">←</span><span>Muokkaa vastauksia</span></button>
							<button class="ayrton-recommender__text-button" type="button" data-restart-button><span>Aloita alusta</span></button>
						</div>
					</div>
				`;
			}

			renderProgramCard(recommendation) {
				const product = recommendation?.product || {};
				const productTitle = product.title || "Ohjelma valitaan pian";
				const productUrl = recommendation?.ctaUrl || product.url || "";
				const productImage = product.image || "";
				const productImageAlt = product?.imageAlt || productTitle;
				const badge = recommendation?.badge || "Ohjelmasuositus";
				const reason = recommendation?.reason || "";
				const ctaLabel = recommendation?.ctaLabel || "Katso ohjelma";
				const buttonStyle = recommendation?.rank === "primary" ? "primary" : "secondary";
				const programNote = recommendation?.noteText
					? `
						<div class="ayrton-recommender__program-note">
							${recommendation.noteTitle ? `<strong>${escapeHTML(recommendation.noteTitle)}</strong>` : ""}
							<span>${escapeHTML(recommendation.noteText)}</span>
						</div>
					`
					: "";

				return `
					<article class="ayrton-recommender__result-card" data-result-card="program" data-recommendation-rank="${escapeAttribute(recommendation?.rank || "primary")}" data-program-key="${escapeAttribute(recommendation?.programKey || "")}">
						<div class="ayrton-recommender__program-media">
							${
								productImage
									? `<img src="${escapeAttribute(productImage)}" alt="${escapeAttribute(productImageAlt)}" loading="lazy">`
									: '<div class="ayrton-recommender__media-placeholder">Suositeltu ohjelma</div>'
							}
						</div>
						<div class="ayrton-recommender__card-content">
							<span class="ayrton-recommender__badge">${escapeHTML(badge)}</span>
							<h3 class="ayrton-recommender__card-title h4">${escapeHTML(productTitle)}</h3>
							<p class="ayrton-recommender__card-text">${escapeHTML(reason)}</p>
							${programNote}
							<div class="ayrton-recommender__card-footer ayrton-recommender__button-list">
								${renderButton(ctaLabel, productUrl, buttonStyle)}
							</div>
						</div>
					</article>
				`;
			}

			renderHealthNoticeCard(notice, settings, cardType = "health") {
				const name = settings.ayrtonName || "Ayrton Kalek";
				const image = settings.ayrtonImage || DEFAULT_AYRTON_IMAGE;
				const initials = name
					.split(" ")
					.map((part) => part[0])
					.join("")
					.slice(0, 2)
					.toUpperCase();

				return `
					<aside class="ayrton-recommender__result-card ayrton-recommender__coach" data-result-card="${escapeAttribute(cardType)}">
						<div class="ayrton-recommender__card-content">
							<div class="ayrton-recommender__coach-header">
								<div class="ayrton-recommender__coach-image">
									${image ? `<img src="${escapeAttribute(image)}" alt="${escapeAttribute(settings.ayrtonImageAlt || name)}" loading="lazy">` : `<span>${escapeHTML(initials)}</span>`}
								</div>
								<div class="ayrton-recommender__coach-name">
									<strong>${escapeHTML(name)}</strong>
									<span>Päävalmentaja</span>
								</div>
							</div>
							<div>
								<h3 class="ayrton-recommender__card-title h4">${escapeHTML(notice.title || "Ayrtonin kommentti")}</h3>
								<p class="ayrton-recommender__card-text">${escapeHTML(notice.text || "")}</p>
							</div>
							<div class="ayrton-recommender__card-footer ayrton-recommender__button-list">
								${renderButton(notice.ctaLabel || "Lue Valmennuksesta", notice.ctaUrl || COACHING_URL, "secondary")}
							</div>
						</div>
					</aside>
				`;
			}
		}

		customElements.define("ayrton-product-recommender", AyrtonProductRecommender);
	}
})();
